module.exports = __webpack_public_path__ + "static/media/mh.5f559ed3.svg";